import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import { picoapp } from 'picoapp';
import Ready from './utils/ready';

// Global
import scrollTriggerSections from './global/scroll-trigger-sections'; // eslint-disable-line
import windowEvents from './global/window-events'; // eslint-disable-line

// App
import announcement from './components/announcement';
import appearSection from './components/appear-section';
import backBtn from './components/back-btn';
import blogFeed from './components/blog-feed';
import campaignDrawer from './components/campaign-drawer';
import cartBtn from './components/cart-btn';
import cartDrawer from './components/cart-drawer'; // eslint-disable-line
import cartItem from './components/cart-item'; // eslint-disable-line
import chatBtn from './components/chat-btn';
import columnDiagrams from './components/column-diagrams';
import './components/cookie-consent';
import countryBtn from './components/country-btn';
import countrySelector from './components/country-selector';
import featureElements from './components/feature-elements';
import harmonicaItem from './components/harmonica-item';
import header from './components/header';
import horizontalDiagrams from './components/horizontal-diagrams';
import imageSlider from './components/image-slider';
import imageTabs from './components/image-tabs';
import largeMedia from './components/large-media';
import lastViewedProducts from './components/last-viewed-products';
import logoSlider from './components/logo-slider';
import menu from './components/menu';
import newsletter from './components/newsletter';
import overlayDrawer from './components/overlay-drawer'; // eslint-disable-line
import productSlider from './components/product-slider';
import progress from './components/progress';
import shippingDate from './components/shipping-date';
import upsellItem from './components/upsell-item'; // eslint-disable-line
import JudgemeApp from './components/judgeme-app';

const initGlobal = () => {
  windowEvents();
  scrollTriggerSections();
};

Ready(initGlobal);

const app = picoapp({
  announcement,
  appearSection,
  backBtn,
  blogFeed,
  cartBtn,
  cartDrawer,
  cartItem,
  chatBtn,
  columnDiagrams,
  countryBtn,
  countrySelector,
  featureElements,
  harmonicaItem,
  horizontalDiagrams,
  header,
  imageSlider,
  imageTabs,
  largeMedia,
  lastViewedProducts,
  logoSlider,
  menu,
  newsletter,
  overlayDrawer,
  productSlider,
  shippingDate,
  upsellItem,
  progress,
  campaignDrawer,
  JudgemeApp
});

app.mount();

export default app;
